import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { MapPinX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';

const InstitutionOnboardingFuturesClientCategorisationJurisdictionUnavailablePage = () => {
  const { t } = useTranslation();

  return (
    <FuturesClientCategorisationLayout className="-md:justify-center" size="sm">
      <div className="flex flex-col relative space-y-8">
        <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
          <MapPinX />
        </GradientIcon>
        <PageHeading centered>
          <PageHeadingTitle className="mb-8">{t('FuturesAppropriatenessClientCategorisation.jurisdictionUnavailable.title')}</PageHeadingTitle>
          <PageHeadingDescription className="whitespace-pre-line">{t('FuturesAppropriatenessClientCategorisation.jurisdictionUnavailable.description')}</PageHeadingDescription>
          <PageHeadingDescription>{t('institutionDetails.futuresOnboarding.continueWithoutFutures')}</PageHeadingDescription>
        </PageHeading>
        <Button size="lg" variant="primary" asChild>
          <Link to="/institution/onboarding/verification" replace>
            {t('institutionDetails.futuresOnboarding.continue')}
          </Link>
        </Button>
      </div>
    </FuturesClientCategorisationLayout>
  );
};
InstitutionOnboardingFuturesClientCategorisationJurisdictionUnavailablePage.displayName = 'InstitutionOnboardingFuturesClientCategorisationJurisdictionUnavailablePage';

export default InstitutionOnboardingFuturesClientCategorisationJurisdictionUnavailablePage;
